// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.w-e-menu {\r\n\tz-index: 2 !important;\n}\n.w-e-text-container,\r\n.w-e-toolbar {\r\n\tz-index: 1 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
